import { Time } from '../types'
import { isTimeDefined } from './isTimeDefined'
import { nullTime } from './nullTime'

export const computeDuration = (start: Time, end: Time): Time => {
  if (!isTimeDefined(start)) return nullTime
  if (!isTimeDefined(end)) return nullTime

  const startMarkInMinutes = start.hour * 60 + start.minute
  const endMarkInMinutes = end.hour * 60 + end.minute

  if (endMarkInMinutes < startMarkInMinutes) return nullTime

  const durationInMinutes = endMarkInMinutes - startMarkInMinutes
  const hour = Math.floor(durationInMinutes / 60)
  const minute = durationInMinutes % 60

  return { hour, minute }
}
